<template>
  <div style="width: 100%">
    <md-table
      v-model="paginatedtableData"
      @md-selected="onSelect"
      :md-sort.sync="currentSort"
      :md-sort-order.sync="currentSortOrder"
      :md-sort-fn="customSort"
    >
      <md-table-empty-state
        md-label="No transactions found"
        :md-description="`No transactions found for the current filters. Try a different search.`"
      >
      </md-table-empty-state>

      <md-table-row
        style="max-height: 400px"
        slot="md-table-row"
        slot-scope="{ item, index }"
        :class="
          selected && item && selected._id == item._id ? 'md-selected-row' : ''
        "
        md-selectable="single"
      >
        <md-table-cell md-label="ID" md-numeric>{{ ((currentPage-1)*rowsPerPage)+index + 1 }}</md-table-cell>
        <md-table-cell md-label="Description" md-sort-by="description">{{
          item.description
        }}</md-table-cell>
        <md-table-cell md-label="Creation Date" md-sort-by="creationDate">{{
          item.creationDateFormat
        }}</md-table-cell>
        <md-table-cell md-label="Created by" md-sort-by="createdBy">{{
          item.creatorLabel
        }}</md-table-cell>

        <md-table-cell
          md-label="Progress"
          md-sort-by="signStatus"
          style="text-align: center"
        >
          <md-icon v-if="item.signStatus == 6" style="color: limegreen"
            >verified</md-icon
          >
          <md-icon
            v-if="item.signStatus == 7 || item.signStatus == 8"
            style="color: #97261e"
            >dangerous</md-icon
          >
          <md-progress-bar
            :class="
              item.reminder ? 'md-alert-date' : item.end ? 'md-danger-date' : ''
            "
            md-mode="determinate"
            :md-value="percState[item.signStatus]"
            style="width: 100%"
            v-if="item.signStatus < 6"
          ></md-progress-bar>
        </md-table-cell>
        <md-table-cell md-label="State" md-sort-by="signStatus">{{
          labelsState[item.signStatus]
        }}</md-table-cell>
        <md-table-cell md-label="Actions">
          <md-button
            class="md-icon-button"
            @click="openPreviewDialog(item._id)"
            title="Preview"
          >
            <md-icon>visibility</md-icon>
          </md-button>
          <md-button
          v-if="isAdmin"
          
            class="md-icon-button"
            @click="openInfoDialog(item)"
            title="Times Info"
          >
            <md-icon>timer</md-icon>
          </md-button>
          <md-button
            class="md-icon-button"
            @click="openAuditDialog(item._id)"
            title="Audit"
          >
            <md-icon>double_arrow</md-icon>
          </md-button>
          <md-button
            class="md-icon-button"
            @click="resendMail(item._id)"
            title="Resend mail"
              :disabled="item.signStatus>=7"
          >
            <md-icon>forward_to_inbox</md-icon>
          </md-button>
          <md-button
            v-if="enableDelete && item.signStatus !== 6"
            class="md-icon-button md-accent"
            @click="deleteTransaction(item._id)"
            title="Delete"
          >
            <md-icon>delete</md-icon>
          </md-button>
          <md-button
            v-if="enableDelete && item.signStatus === 7"
            class="md-icon-button md-primary"
            @click="reopenTransaction(item._id)"
            title="Reopen"
          >
            <md-icon>rotate_left</md-icon>
          </md-button>
          <md-button
            v-if="enableDelete && item.signStatus === 3"
            class="md-icon-button md-accent"
            @click="rejectTransaction(item._id)"
            title="Reject"
          >
            <md-icon>thumb_down_alt</md-icon>
          </md-button>
          <md-button
            v-if="item.signStatus === 0"
            class="md-icon-button md-primary"
            @click="$router.push({
              path: 'edit',
              query: { transactionId: item._id },
            });"
            title="Sumbit"
          >
            <md-icon>add_task</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <div
      class="md-layout md-gutter md-alignment-center-center"
      style="margin-top: 15px; max-height: 400px; padding-right: 25px"
      v-if="paginatedtableData.length > 0"
    >
      <span
        class="md-layout-item md-xlarge-size-15 md-large-size-15 md-medium-size-15 md-small-size-50"
        >Rows per page:</span
      >
      <div
        class="md-layout-item md-xlarge-size-10 md-large-size-10 md-medium-size-10 md-small-size-50"
      >
        <md-field>
          <md-select
            v-model="rowsPerPage"
            @md-selected="
              currentPage = 1;
              updatePagination();
            "
          >
            <md-option value="5">5</md-option>
            <md-option value="10">10</md-option>
            <md-option value="15">15</md-option>
            <md-option value="20">20</md-option>
          </md-select>
        </md-field>
      </div>

      <span
        class="md-layout-item md-xlarge-size-20 md-large-size-20 md-medium-size-20 md-small-size-40"
      >
        {{
          "Transactions " +
          (initialRow + 1) +
          "-" +
          finalRow +
          " of " +
          totalRows
        }}</span
      >
      <div
        class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-5 md-small-size-20"
      >
        <md-button
          class="md-icon-button"
          @click="
            currentPage -= 1;
            updatePagination();
          "
          :disabled="currentPage == 1"
          title="Prev. Page"
        >
          <md-icon>chevron_left</md-icon>
        </md-button>
      </div>
      <div
        class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-5 md-small-size-20"
      >
        <md-button
          class="md-icon-button"
          @click="
            currentPage += 1;
            updatePagination();
          "
          :disabled="currentPage == totalPages"
          title="Next Page"
        >
          <md-icon>chevron_right</md-icon>
        </md-button>
      </div>

      <div
        v-if="isAdmin"
        class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-5 md-small-size-20"
      >
        <div class="md-layout md-gutter md-alignment-center-right">
          <md-button
            class="md-icon-button"
            @click="generateReport()"
            title="Download as Report"
          >
            <md-icon>download</md-icon>
          </md-button>
        </div>
      </div>
    </div>

    <md-dialog class="wide-dialog infodialog" :md-active.sync="showInfoDialog">
      <md-dialog-title class="md-dialog-title"
        >Reminder and cancel info</md-dialog-title
      >

      <div class="auto-size">
        <form action="" autocomplete="off">
          <div
            style="margin: 30px 80px"
            v-for="(stage, index) in ['initial', 'sign', 'final', 'cancel']"
            :key="index"
          >
            <div style="margin-bottom: 15px; display: flex; position: relative">
              <span>
                <md-icon v-if="stage != 'cancel'">timer</md-icon>
                <md-icon v-if="stage == 'cancel'">event_busy</md-icon>
              </span>
              <span>
                <h3 style="padding: 2px 7px">
                  {{ reminderInfoLabels[stage] }}
                </h3>
              </span>
              <span style="position: absolute; right: 0; top: -13px">
                <!-- <md-switch
                  v-model="useDateCancel"
                  class="md-primary"
                  v-if="stage == 'cancel'"
                >
                  Use calendar
                </md-switch> -->
                </span
              >
            </div>
            <div :style="'display: flex;'+(selected.signStatus>=6?'opacity:0.75;':'')" v-if="!!infoSelectedData[stage].units">
              <md-field v-if="stage != 'cancel' || !useDateCancel">
                <label>{{
                  stage == "cancel" ? "Cancel in" : "Remind every"
                }}</label>
                <md-input
                 :disabled="selected.signStatus>=6"
                type="number"
                  v-model="infoSelectedData[stage].count"
                  autocomplete="off"
                ></md-input>
              </md-field>
              <md-field v-if="stage != 'cancel' || !useDateCancel">
                <md-select
                :disabled="selected.signStatus>=6"
                  v-model="infoSelectedData[stage].units"
                  placeholder="Units"
                >
                  <!-- <md-option value="0">Hours*</md-option> -->
                  <md-option value="1">Day(s)</md-option>
                  <md-option value="2">Week(s)</md-option>
                  <md-option value="3">Month(s)</md-option>
                </md-select>
              </md-field>
<!-- 
              <md-datepicker
                class="md-layout-item"
                v-model="selectedCancelDate"
                v-if="stage == 'cancel' && useDateCancel"
              >
                <label>Cancel date</label>
              </md-datepicker> -->
              <CustomDateField  class="md-layout-item" v-if="stage == 'cancel' && useDateCancel" label="Cancel date" v-model="selectedCancelDate" fromToday  :disabled="selected.signStatus>=6"/>

              <md-button
             v-if="((selected.signStatus<6)&&(stage !== 'cancel'))"
                class="md-mini"
                style="min-width: unset"
                @click="
                  () => {
                    infoSelectedData[stage].units = undefined;
                    infoSelectedData[stage].count = undefined;
                    $forceUpdate();
                  }
                "
              >
                <md-icon>close</md-icon>
              </md-button>
            </div>
            <!-- <div v-if="stage == 'cancel' && !!infoSelectedData.cancel.units">
              {{
                "Expire date: " +
                getExpiredDate(infoSelectedData.transaction, true)
              }}
            </div> -->
            <div
              v-if="!infoSelectedData[stage].units"
              style="font-size: 1.1rem; margin-top: 25px; margin-bottom: 20px"
            >
              <span style="opacity: 0.7">{{
                stage == "cancel" ? "No cancel time set" : "No reminder set"
              }}</span>
              <md-button
 v-if="selected.signStatus<6"
              class="md-fab md-mini md-primary"
                style="scale: 0.7; top: -15px"
                @click="
                  () => {
                    infoSelectedData[stage].units = 1;
                    infoSelectedData[stage].count = 1;
                    $forceUpdate();
                  }
                "
              >
                <md-icon>add</md-icon>
              </md-button>
            </div>
          </div>
        </form>
      </div>
      <md-dialog-actions>
        <md-button @click="showInfoDialog = false">Close</md-button>
        <md-button class="md-primary" @click="updateTransactionTimes()"
          >Save</md-button
        >
      </md-dialog-actions>
    </md-dialog>
    <md-dialog class="wide-dialog big-dialog" :md-active.sync="showPreviewDialog" >
      <md-dialog-title class="md-dialog-title">Preview</md-dialog-title>

      <div class="auto-size">
        <iframe
          :src="previewUrl + '&iframe=1'"
          style="height: 100%; width: 100%"
        >
        </iframe>
      </div>
      <md-dialog-actions>
        <md-button @click="showPreviewDialog = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog class="wide-dialog big-dialog" :md-active.sync="showAuditDialog">
      <md-dialog-title class="md-dialog-title"
        >Audit trail for the signature transaction ID:
        {{ selected._id }}</md-dialog-title
      >

      <div class="auto-size">
        <iframe :src="auditUrl + '&iframe=1'" style="height: 100%; width: 100%">
        </iframe>
      </div>
      <md-dialog-actions>
        <md-button @click="showAuditDialog = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog class="wide-dialog" :md-active.sync="confirmDeleteDialog">
      <md-dialog-title class="md-dialog-title"
        >Delete Transaction</md-dialog-title
      >

      <div class="dialog-content spaced">
        <p>Do you really want to delete this Transaction?</p>
        <p>Id: {{ deleteSelected }}</p>
      </div>
      <md-dialog-actions>
        <md-button @click="confirmDeleteDialog = false">Cancel</md-button>
        <md-button class="md-accent" @click="sendDeleteRequest()"
          >Delete</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <md-dialog-confirm
      :md-active.sync="confirmAddTimesReopen"
      md-title="Set remider and cancel times"
      md-content="Do you want to set new reminder and cancel times for the re opened transaction?"

      @md-cancel="this.reopenSelected = false;confirmAddTimesReopen=false"
      @md-confirm="confirmAddTimesReopen=false;openInfoDialog((tableData||[]).find(e=>e._id==reopenSelected)); this.reopenSelected = false;" />

    <md-dialog class="wide-dialog" :md-active.sync="confirmReopenDialog">
      <md-dialog-title class="md-dialog-title"
        >Reopen Transaction</md-dialog-title
      >

      <div class="dialog-content spaced">
        <p>Do you really want to reopen this Transaction?</p>
        <p>Id: {{ reopenSelected }}</p>
      </div>
      <md-dialog-actions>
        <md-button @click="confirmReopenDialog = false">Cancel</md-button>
        <md-button class="md-primary" @click="sendReopenRequest()"
          >Reopen</md-button
        >
      </md-dialog-actions>
    </md-dialog>
    <md-dialog class="wide-dialog" :md-active.sync="confirmRejectDialog">
      <md-dialog-title class="md-dialog-title"
        >Reject Transaction</md-dialog-title
      >

      <div class="dialog-content spaced">
        <p>Do you really want to reject this Transaction?</p>
        <p>Id: {{ rejectSelected }}</p>
        <md-field style="margin-top: 20px">
          <label>Comment</label>
          <md-textarea
            required
            placeholder="Please explain the reason to reject the transaction...*"
            v-model="rejectComment"
          ></md-textarea>
        </md-field>
      </div>
      <md-dialog-actions>
        <md-button
          @click="
            rejectComment = '';
            confirmRejectDialog = false;
          "
          >Cancel</md-button
        >
        <md-button
          :disabled="!rejectComment"
          class="md-accent"
          @click="sendRejectRequest()"
          >Reject</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import Vue from "vue";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import CustomDateField from "@/components/CustomDateField.vue";
export default {
  components: {
            CustomDateField,
        },
  props: {
    searchFilters: {},
    enableDelete: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    searchFilters: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler(newData, oldval) {
        if (
          newData != oldval &&
          typeof newData != "undefined" &&
          typeof newData["userId"] != "undefined"
        ) {
          this.refreshData(newData);
          console.log("newData", newData);
        }
      },
    },
  },
  data() {
    return {
      selectedCancelDate: "",
      useDateCancel: true,
      dateTimeFormat: Vue.prototype.$generalConfiguration["dateTimeFormat"],
      dateFormat: Vue.prototype.$generalConfiguration["dateFormat"],
      reminderInfoLabels: {
        initial: "Reminder for initial approvers",
        sign: "Reminder for recipients",
        final: "Reminder for final approvers",
        cancel: "Cancellation time for transaction",
      },
      tableData: [],
      //labelsState :  ['Initial','Released', 'Sent','Sign','Signed','Approved','Expired','Rejected'],
      labelsState: [
        "To submit",
        "To first approve",
        "To first approve",
        "To sign",
        "To sign",
        "To final approve",
        "Approved",
        "Expired",
        "Rejected",
      ],
      percState: [0, 15, 25, 35, 50, 75, 100],
      rowsPerPage: 5,
      currentPage: 1,
      totalPages: 1,
      initialRow: 1,
      finalRow: 1,
      totalRows: 1,
      previewUrl: "",
      auditUrl: "",
      selected: {},
      creators: [],
      selectedCreators: [],
      dialogSelectedCreators: [],
      paginatedtableData: [],
      infoSelectedData: { initial: {}, final: {}, sign: {}, cancel: {} },
      showPreviewDialog: false,
      showInfoDialog: false,
      showAuditDialog: false,
      confirmDeleteDialog: false,
      role: null,
      isAdmin: false,
      currentSortOrder: "desc",
      currentSort: "creationDate",
      deleteSelected: null,
      reopenSelected: null,
      confirmReopenDialog: false,
      confirmAddTimesReopen: false,
      rejectSelected: null,
      rejectComment: "",
      confirmRejectDialog: false,
    };
  },
  methods: {
     adjustDate(date){

const date1 = new Date();
const date2 = date;
const diffTime = Math.abs(date2 - date1);
const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); 


let days = diffDays+1;
   


      var expireDate = new Date();
      var today = new Date();
      expireDate.setDate(today.getDate() + days );
     
      return expireDate;
    },
    getExpiredDate(transaction, usePopUP, dateObj) {
      const element = transaction;

      let days = Number(
        usePopUP ? this.infoSelectedData.cancel.count : element.cancelTime.count
      );
      let multiplier = 1;
      switch (
        Number(
          usePopUP
            ? this.infoSelectedData.cancel.units
            : element.cancelTime.units
        )
      ) {
        case 2:
          multiplier = 7;
          break;
        case 3:
          multiplier = 30;
          break;
      }

      var expireDate = new Date();
      var creationDate = new Date(element.creationDate);
      expireDate.setDate(creationDate.getDate() + days * multiplier);

if(!usePopUP && !!transaction.expireDate){
  expireDate=transaction.expireDate;
}

if(dateObj){
  return moment(expireDate).toDate();
}
      return moment(expireDate).format(this.dateTimeFormat);
    },
    customSort() {
      return this.tableData
        .sort((a, b) => {
          const sortBy = this.currentSort;
          var valA, valB;
          switch (sortBy) {
            case "createdBy":
              valA = a[sortBy]["firstName"];
              valB = b[sortBy]["firstName"];
              break;
            case "signStatus":
              valA = JSON.stringify(a[sortBy]);
              valB = JSON.stringify(b[sortBy]);
              break;

            default:
              valA = a[sortBy];
              valB = b[sortBy];
              break;
          }
          if (this.currentSortOrder !== "desc") {
            return valA.localeCompare(valB);
          }
          return valB.localeCompare(valA);
        })
        .filter((element, index) => {
          return index >= this.initialRow && index < this.finalRow;
        });
    },
    onSelect(item) {
      if (item != null) {
        this.selected = item;
        this.$emit("transactionIdChanged", item._id);
      }
    },
    refreshData(filters, samePage) {
      let loader = this.$loading.show({
        loader: "dots",
        color: "#e94e1b",
        backgroundColor: "#6B6B6B",
        height: 155,
        width: 155,
      });
      axios({
        method: "post",
        url: this.isAdmin ? "/sign/transactions" : "/sign/tasks",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        data: { ...filters },
      })
        .then((response) => {
          this.tableData = response.data;
          this.$emit("dataFound", this.tableData.length > 0);

          this.tableData.forEach((element) => {
            element.creationDateFormat = moment(element.creationDate).format(
              this.dateTimeFormat
            );
            element.creatorLabel =
              element.createdBy.firstName + " " + element.createdBy.lastName;
          });
          if(!samePage){
            this.currentPage = 1;

          }
          // this.tableData = this.searchArray(this.tableData,'*es')
          this.updatePagination();
          loader.hide();
        })
        .catch(function () {
          console.log("FAILURE!!");
          loader.hide();
        });
    },
    searchArray(arr, str) {
      // If there are no items in the array, return an empty array
      if (typeof arr === "undefined" || arr.length === 0) return [];
      // If the string is empty return all items in the array
      if (typeof str === "undefined" || str.length === 0) return arr;

      // Create a new array to hold the results.
      var res = [];
      console.log(str);
      // Check where the start (*) is in the string
      var starIndex = str.indexOf("*");

      // If the star is the first character...
      if (starIndex === 0) {
        // Get the string without the star.
        str = str.substr(1);
        for (var i = 0; i < arr.length; i++) {
          // Check if each item contains an indexOf function, if it doesn't it's not a (standard) string.
          // It doesn't necessarily mean it IS a string either.
          if (!arr[i].indexOf) continue;

          // Check if the string is at the end of each item.
          if (arr[i].indexOf(str) === arr[i].length - str.length) {
            // If it is, add the item to the results.
            res.push(arr[i]);
          }
        }
      }
      // Otherwise, if the star is the last character
      else if (starIndex === str.length - 1) {
        // Get the string without the star.
        str = str.substr(0, str.length - 1);
        for (var j = 0; j < arr.length; j++) {
          // Check indexOf function
          if (!arr[j].indexOf) continue;
          // Check if the string is at the beginning of each item
          if (arr[j].indexOf(str) === 0) {
            // If it is, add the item to the results.
            res.push(arr[j]);
          }
        }
      }
      // In any other case...
      else {
        for (var k = 0; k < arr.length; k++) {
          // Check indexOf function
          if (!arr[k].indexOf) continue;
          // Check if the string is anywhere in each item
          if (arr[k].indexOf(str) !== -1) {
            // If it is, add the item to the results
            res.push(arr[k]);
          }
        }
      }

      // Return the results as a new array.
      return res;
    },
    sendDeleteRequest() {
      axios({
        method: "delete",
        url: "/sign/transaction",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        params: {
          transactionId: this.deleteSelected,
        },
      })
        .then(() => {
          this.confirmDeleteDialog = false;
          this.deleteSelected = null;
          this.refreshData(this.searchFilters);
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    sendReopenRequest() {
      axios({
        method: "get",
        url: "/sign/reopen",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        params: {
          transactionId: this.reopenSelected,
          reOpenUserId: Vue.prototype.$userData.user.id,
        },
      })
        .then(() => {
          
          this.confirmReopenDialog = null;
          this.refreshData(this.searchFilters, true);
          this.confirmAddTimesReopen=true;
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    sendRejectRequest() {
      axios({
        method: "put",
        url: "/sign/reject",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        data: {
          comment: this.rejectComment,
        },
        params: {
          transactionId: this.rejectSelected,
        },
      })
        .then(() => {
          this.rejectSelected = false;
          this.confirmRejectDialog = null;
          this.refreshData(this.searchFilters);
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    updateTransactionTimes() {
      console.log("updateTransactionTimes");
      if(this.selectedCancelDate){

const date1 = new Date(this.selected.creationDate);
const date2 = this.selectedCancelDate;
const diffTime = Math.abs(date2 - date1);
const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 

this.selected.cancelTime={units:1, count:diffDays};
}else{
this.selected.cancelTime=1;
}

this.selected.reminderTimes={};

      this.selected.reminderTimes.initial = [this.infoSelectedData.initial];
      this.selected.reminderTimes.final = [this.infoSelectedData.final];
      this.selected.reminderTimes.sign = [this.infoSelectedData.sign];

      const transactionId = this.selected._id;
      const transactionData = { ...this.selected };

   
        transactionData.expireDate=this.selectedCancelDate?this.adjustDate(this.selectedCancelDate): null;
   
      delete transactionData._id;
      delete transactionData.__v;
      delete transactionData.createdAt;
      delete transactionData.updatedAt;
      delete transactionData.refEmail;
      delete transactionData.creationDateFormat;
      delete transactionData.createdBy;
      delete transactionData.creatorLabel;

      axios({
        method: "put",
        url: "/sign/transaction",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        params: {
          transactionId: transactionId,
        },
        data: transactionData,
      })
        .then(() => {
          console.log("put SUCCESS!!");
          this.refreshData(this.searchFilters, true);
        })
        .catch(function () {
          console.log("put FAILURE!!");
        });

      this.showInfoDialog = false;
    },

    openInfoDialog(selected) {
      this.selected = selected;
      let cancelTime = {};
      if (typeof selected.cancelTime === "object") {
        cancelTime = selected.cancelTime;
        this.selectedCancelDate = this.getExpiredDate(selected, false, true) || null;
      }else{
        this.selectedCancelDate = null;
      }

      let reminderTimes = {
        final: [],
        initial: [],
        sign: [],
      };
      if (typeof selected.reminderTimes === "object") {
        reminderTimes = selected.reminderTimes;
      }
      const clone = (obj) => {
        return JSON.parse(JSON.stringify(obj));
      };
      this.infoSelectedData = {
        transaction: selected,
        initial: clone(reminderTimes?.initial?.[0] || {}),
        final: clone(reminderTimes?.final?.[0] || {}),
        sign: clone(reminderTimes?.sign?.[0] || {}),
        cancel: clone(cancelTime || {}),
      };

      this.showInfoDialog = true;
    },
    openPreviewDialog(selected) {
      this.previewUrl =
        (window.location.protocol == "https:" ? "http" : "http://") +
        location.host +
        "/" +
        (process.env.VUE_APP_BASE_WEB || "cartago-digital") +
        "/show_frame?transactionId=" +
        selected;
      this.showPreviewDialog = true;
    },
    resendMail(transactionId) {
      axios({
        method: "post",
        url: "/sign/resend",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        params: {
          transactionId: transactionId,
        },
      })
        .then(() => {
          Vue.$toast.open({
            message: "Email has been sent",
            position: "bottom",
            type: "success",
          });
        })
        .catch(function () {
          Vue.$toast.open({
            message: "Error sending the email",
            position: "bottom",
            type: "error",
          });
        });
    },
    openAuditDialog(selected) {
      this.auditUrl =
        (window.location.protocol == "https:" ? "http" : "http://") +
        location.host +
        "/" +
        (process.env.VUE_APP_BASE_WEB || "cartago-digital") +
        "/trail_frame?transactionId=" +
        selected;

      this.showAuditDialog = true;
    },
    deleteTransaction(selected) {
      this.deleteSelected = selected;
      this.confirmDeleteDialog = true;
    },
    reopenTransaction(selected) {
      this.reopenSelected = selected;
      this.confirmReopenDialog = true;
    },
    rejectTransaction(selected) {
      this.rejectSelected = selected;
      this.confirmRejectDialog = true;
    },
    updatePagination() {
      this.totalRows = this.tableData.length;

      this.totalPages = Math.ceil(this.totalRows / this.rowsPerPage);
      this.initialRow = (this.currentPage - 1) * this.rowsPerPage;
      this.finalRow = this.currentPage * this.rowsPerPage;
      if (this.finalRow > this.totalRows) {
        this.finalRow = this.totalRows;
      }
      this.paginatedtableData = this.customSort();
    },
    generateReport() {
      axios({
        method: "post",
        url: "/sign/transactions",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        data: { ...this.searchFilters },
      })
        .then((response) => {
          let tableData = response.data.map((element) => {
            const tableRow = [
              element.createdBy.firstName + " " + element.createdBy.lastName,
              element.description,
              moment(element.creationDate).format(this.dateTimeFormat),
              this.labelsState[element.signStatus],
            ];
            return tableRow;
          });

          var img = new Image();
          img.style='max-height:80px;';
          img.src = localStorage.getItem("generalConfiguration") ? JSON.parse(localStorage.getItem("generalConfiguration"))["imageFile"] : "https://i.ibb.co/wQ3pYrd/Logo-5x2.png";
       
       //   img.src = "https://i.ibb.co/wQ3pYrd/Logo-5x2.png";
          img.onload = () => {
            const doc = new jsPDF({
              orientation: "portrait",
            });
            const w=img.width;
            const h=img.height;
            const newW=(20*w)/h;
            doc.addImage(img, "png", 20, 10, newW, 20);
            doc.text("Transactions Report", 150, 15);
            doc.text("Date: " + moment().format(this.dateFormat), 157, 30);
            doc.line(0, 40, 400, 40);
            autoTable(doc, {
              head: [["Created By", "Description", "Creation Date", "State"]],
              margin: { top: 50 },
              body: tableData,
            });
            doc.text("Generated by Cartago Sign", 10, 290);
            doc.save("transactions_report.pdf");
          };

          //
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
  },
  mounted() {
    this.role = Vue.prototype.$userData.user.role[0];

    this.isAdmin = Vue.prototype.$userData.user.role.includes("admin");
  },
};
</script>

<style lang="scss">
.infodialog .md-dialog-container {
  max-width: 40%;
}
.md-table + .md-table {
  margin-top: 16px;
}

.dialog-content {
  padding: 0px;

  &.spaced {
    overflow-y: auto;
    margin: 20px;
  }
}

.auto-size {
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
}

.md-dialog-title {
  background-color: #e94e1b;
  margin: 0px;
  padding: 20px;
  color: white;
}

.md-selected-row {
  background-color: #dddddd !important;
}

.md-progress-bar.md-determinate.md-theme-default {
  background-color: #8b7b7b !important;
  height: 8px;
}

.md-progress-bar.md-theme-default.md-determinate.md-danger-date
  .md-progress-bar-fill {
  background-color: #97261e !important;
}

.md-progress-bar.md-theme-default.md-determinate.md-alert-date
  .md-progress-bar-fill {
  background-color: #d86901 !important;
}

.md-content.md-table-content.md-theme-default {
  background-color: transparent !important;
}

.md-content.md-table.md-theme-default {
  background-color: transparent !important;
}

@media (max-width: 600px) {
  .auto-size {
    height: 90%;
  }
}

@media (min-width: 601px) {
  .auto-size {
    height: 100%;
  }
  .big-dialog .md-dialog-container {
    height: 80%;
  }

  .wide-dialog .md-dialog-container {
    width: 80%;
  }
}
</style>
